import { halftoneDefinition, type HalftoneParameters } from "./halftone";
import { noiseDefinition, type NoiseParameters } from "./noise";
import type { EffectInstance } from "./effectTypes";

export type HalftoneInstance = EffectInstance<HalftoneParameters> & { definitionId: "halftone" };
export type NoiseInstance = EffectInstance<NoiseParameters> & { definitionId: "noise" };
export type AlterlyEffectInstance = HalftoneInstance | NoiseInstance;
export type AlterlyEffectId = AlterlyEffectInstance["definitionId"];

export const effectRegistry = {
  halftone: halftoneDefinition,
  noise: noiseDefinition,
} as const;

function instanceId(definitionId: AlterlyEffectId) {
  const suffix = typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `${definitionId}-${suffix}`;
}

export function createEffectInstance(definitionId: "halftone"): HalftoneInstance;
export function createEffectInstance(definitionId: "noise"): NoiseInstance;
export function createEffectInstance(definitionId: AlterlyEffectId): AlterlyEffectInstance;
export function createEffectInstance(definitionId: AlterlyEffectId): AlterlyEffectInstance {
  if (definitionId === "halftone") {
    return {
      instanceId: instanceId(definitionId),
      definitionId,
      enabled: true,
      opacity: 1,
      parameters: { ...halftoneDefinition.defaults },
    };
  }

  return {
    instanceId: instanceId(definitionId),
    definitionId,
    enabled: true,
    opacity: 1,
    parameters: { ...noiseDefinition.defaults },
  };
}

export function cloneEffectInstance(effect: AlterlyEffectInstance): AlterlyEffectInstance {
  if (effect.definitionId === "halftone") {
    return {
      ...effect,
      instanceId: instanceId(effect.definitionId),
      parameters: { ...effect.parameters },
    };
  }

  return {
    ...effect,
    instanceId: instanceId(effect.definitionId),
    parameters: { ...effect.parameters },
  };
}
